module.exports = __webpack_public_path__ + "static/media/Border.720be532.svg";